import type { SVGProps } from "react";
export interface IslandIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function IslandIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: IslandIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.691 19.883a1.77 1.77 0 0 1 1.95 0l.123.09.196.15c.46.333 1.129.696 1.868.746l.172.006.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006-.314-.01c-1.305-.086-2.371-.686-3.02-1.152-.701.503-1.886 1.162-3.333 1.162s-2.634-.66-3.334-1.162c-.7.503-1.885 1.162-3.333 1.162s-2.633-.66-3.333-1.162c-.701.503-1.885 1.162-3.333 1.162a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.513 2.237-.901l.121-.09a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.357 1.233.75 2.04.75.922 0 1.755-.512 2.236-.9l.122-.09a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.357 1.232.75 2.039.75.922 0 1.755-.512 2.237-.9zM12 .875a1.126 1.126 0 0 1 0 2.25c-.656 0-1.284.242-1.854.615a5.7 5.7 0 0 1 1.62.604l.357.22.093.068a1.124 1.124 0 0 1-1.24 1.864l-.1-.06-.216-.132a3.3 3.3 0 0 0-1.598-.43 2.1 2.1 0 0 0-.958.204c0 .073-.004.153-.003.24.007.474.05 1.145.192 1.915.272 1.47.9 3.246 2.28 4.739a10.5 10.5 0 0 1 2.94.013 5.43 5.43 0 0 0 2.37-2.326c.136-.256.234-.497.31-.7-.47-.18-.993-.068-1.398.336a1.125 1.125 0 1 1-1.59-1.59 3.65 3.65 0 0 1 1.706-.973 1 1 0 0 0-.258-.092l-.154-.015-.114-.006a1.125 1.125 0 0 1 .114-2.244l.293.013c1.276.118 2.166.994 2.708 1.726.581-.787 1.567-1.739 3-1.739a1.125 1.125 0 0 1 0 2.25.9.9 0 0 0-.412.107c.507.126.996.362 1.43.72l.278.253.076.085a1.125 1.125 0 0 1-1.582 1.583l-.085-.078-.108-.098c-.48-.401-1.095-.428-1.593-.079-.017.063-.031.132-.054.205a7.96 7.96 0 0 1-2.207 3.491 9.5 9.5 0 0 1 2.58 1.854l.29.3.073.09a1.126 1.126 0 0 1-1.647 1.516l-.082-.08-.223-.233c-1.149-1.155-2.817-2.136-5.234-2.136-2.577 0-4.305 1.116-5.458 2.369l-.082.08a1.125 1.125 0 0 1-1.573-1.605l.29-.3a9.4 9.4 0 0 1 3.013-2.051c-1.246-1.68-1.836-3.501-2.109-4.975a14 14 0 0 1-.23-2.291c-.002-.106.004-.205.004-.296a2.2 2.2 0 0 0-.918-.181c-.592 0-1.25.185-1.813.56a1.125 1.125 0 0 1-1.249-1.872 5.6 5.6 0 0 1 1.978-.823c-.57-.373-1.196-.615-1.853-.615a1.125 1.125 0 0 1 0-2.25c1.942 0 3.465 1.124 4.42 2.08.215.214.408.429.58.631.171-.203.365-.416.58-.63C8.535 1.998 10.058.874 12 .874Z"
      />
    </svg>
  );
}
